export default function popups() {
    document.addEventListener('DOMContentLoaded', function() {
        const popups = document.querySelectorAll('.popup-modal');
        
        if (popups.length === 0) return;
        
        let currentPopupIndex = 0;
        const viewedPopups = JSON.parse(localStorage.getItem('viewedPopups') || '{}');
        const now = Date.now();
        const thirtyMinutes = 30 * 60 * 1000; // 30 minutos em milissegundos
        
        // Limpar popups visualizados há mais de 30 minutos
        const validPopups = {};
        for (const [popupId, timestamp] of Object.entries(viewedPopups)) {
            if (now - timestamp < thirtyMinutes) {
                validPopups[popupId] = timestamp;
            }
        }
        localStorage.setItem('viewedPopups', JSON.stringify(validPopups));
        
        function showPopup(index) {
            if (index >= popups.length) return;
            
            const popup = popups[index];
            const popupId = popup.dataset.popupId;
            
            // Verificar se já foi visualizado nos últimos 30 minutos
            if (validPopups[popupId] && (now - validPopups[popupId] < thirtyMinutes)) {
                showNextPopup();
                return;
            }
            
            popup.style.display = 'flex';
            document.body.classList.add('popup-open');
        }
        
        function markPopupAsViewed(popupId) {
            // Marcar como visualizado com timestamp atual
            validPopups[popupId] = Date.now();
            localStorage.setItem('viewedPopups', JSON.stringify(validPopups));
        }
        
        function hidePopup(popup) {
            popup.style.display = 'none';
            document.body.classList.remove('popup-open');
        }
        
        function showNextPopup() {
            currentPopupIndex++;
            if (currentPopupIndex < popups.length) {
                setTimeout(() => showPopup(currentPopupIndex), 300);
            }
        }
        
        // Event listeners para fechar
        popups.forEach((popup, index) => {
            const closeBtn = popup.querySelector('.popup-close');
            const overlay = popup.querySelector('.popup-overlay');
            const popupId = popup.dataset.popupId;
            
            closeBtn.addEventListener('click', () => {
                markPopupAsViewed(popupId);
                hidePopup(popup);
                showNextPopup();
            });
            
            overlay.addEventListener('click', () => {
                markPopupAsViewed(popupId);
                hidePopup(popup);
                showNextPopup();
            });
            
            // ESC key
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && popup.style.display === 'flex') {
                    markPopupAsViewed(popupId);
                    hidePopup(popup);
                    showNextPopup();
                }
            });
        });
        
        // Mostrar primeiro popup após 1 segundo
        setTimeout(() => showPopup(0), 1000);
    });
}